import { render } from "./DocsEnglish.vue?vue&type=template&id=66f88058"
import script from "./DocsEnglish.vue?vue&type=script&lang=js"
export * from "./DocsEnglish.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__